import { api } from "api";
import dayjs, { Dayjs } from "dayjs";

import { IHotelSearchItem } from "types";

type Dates = { checkIn: Dayjs; checkOut: Dayjs };

export class Hotels {
  private checkIn: Dayjs = dayjs();
  private checkOut: Dayjs = dayjs().add(1, "day");

  public list: IHotelSearchItem[] = [];

  constructor(private country: string, private name: string, dates?: Dates) {
    this.name = name;
    this.country = country;

    if (dates) {
      this.checkIn = dates.checkIn;
      this.checkOut = dates.checkOut;
    }
  }

  public async search() {
    try {
      const response = await api.hotels.list({
        placeName: this.name,
        checkIn: this.checkIn,
        country: this.country,
        checkOut: this.checkOut,
      });

      const { tasks } = response.data;
      const result = tasks.length > 0 ? tasks[0].result : null;

      if (result && result.length > 0) {
        const { items } = result[0];
        if (items) {
          this.list = items.map((item) => ({
            ...item,
            infoRequest: { location_name: this.country },
          }));
        }
      }

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async info(hotelID: string) {
    try {
      const response = await api.hotels.info({
        hotelID,
        checkIn: this.checkIn,
        country: this.country,
        checkOut: this.checkOut,
      });

      const { tasks } = response.data;
      const result = tasks.length > 0 ? tasks[0].result : null;

      if (result && result.length > 0) {
        const data = result[0];
        return Promise.resolve(data);
      }

      return Promise.resolve(undefined);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
